import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plus-sm",
  "use": "plus-sm-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"plus-sm\"><path d=\"M8.5 5c-.5 0-.5.5-.5.5V8H5.5S5 8 5 8.5s.5.5.5.5H8v2.5s0 .5.5.5.5-.5.5-.5V9h2.5s.5 0 .5-.5-.5-.5-.5-.5H9V5.5S9 5 8.5 5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol